/**
 * Licensed Materials - Property of IBM IBM Cognos Products: BI Cloud (C)
 *
 * Copyright IBM Corp. 2016, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/dashboard-common/dist/ui/SearchableListView',
	'../../lib/@waca/core-client/js/core-client/utils/Deferred',
	'../../app/nls/StringResources',
	'underscore',
	'doT',
	'text!./templates/CustomWidgetListItem.html',
	'text!./templates/EmptyWidgetList.html'
],
function(BaseView, Deferred, stringResources, _, dot, itemTemplate, emptyTemplate) {

	const WidgetListView = BaseView.extend({

		itemTemplate: itemTemplate,

		events: {
			'clicktap .listitem': 'onItemClick',
			'mousedown .listitem': 'onItemStartDrag',
			'drag .listitem': 'onItemStartDrag'
		},

		init: function(options) {
			WidgetListView.inherited('init', this, arguments);
			this.options = options || {};
			this.glassContext = options.glassContext;
			this.services = options.services;
			this.dashboardApi = options.dashboardApi;
			this.whenIsReadyDfd = new Deferred();
			this._initialize();
		},

		whenIsReady: function() {
			return this.whenIsReadyDfd.promise;
		},

		accepts: function(){
			return true;
		},

		remove: function() {
			if (this._dropZone) {
				this._dropZone.remove();
				this._dropZone = null;
			}
			WidgetListView.inherited('remove', this, arguments);
		},

		render: function() {
			var dfd = WidgetListView.inherited('render', this);

			dfd.then(function() {
				if (!this.list || this.list.length === 0) {
					var empty = dot.template(emptyTemplate);
					this.$el.find('.list').append(empty({
						text: stringResources.get('noCustomWidgets')
					}));
				}
			}.bind(this));

			return dfd;
		},

		_initialize: function() {
			const DndManager = this.dashboardApi.getFeature('DashboardDnd.internal');
			this.whenIsReadyDfd.resolve();
			this._dropZone = DndManager.addDropTarget(this.$el[0], {
				accepts: this.accepts.bind(this)
			});
		},

		_getEntry: function(ev){
			var target = this.getTarget(ev.target, 'listitem');
			var dataId = target.getAttribute('data-id');
			// lookup with the id
			return this.widgetMap[dataId];
		},

		onItemClick: function(ev){
			if (this.options.onItemClick){
				var entry = this._getEntry(ev);
				this.options.onItemClick(entry, ev);

				if (ev && ev.gesture){
					ev.gesture.preventDefault();
				}
			}
		},

		onItemStartDrag: function(ev){
			if (this.options.onItemStartDrag){
				var entry = this._getEntry(ev);
				this.options.onItemStartDrag(entry, ev);
			}
		},

		/**
		 * Override to provide the list of all custom widgets
		 */
		getListItems: function() {
			this.$el.empty();

			return this.options.getEntries({ glassContext: this.options.glassContext })
				.then((content) => {
					this.list = content.list;

					// create the lookup map
					this.widgetMap = _.object(_.map(content.list, function(item) {
						return [item.id, item];
					}));

					return this.list;
				});
		},

		/**
		 * Override to enable search
		 */
		getCustomRenderProperties: function() {
			return {
				searchText: stringResources.get('find_label')
			};
		},

		/**
		 * Override to provide the searchable custom widgets
		 */
		_getSearchableItems: function() {
			return this.list;
		},

		/**
		 * Override to provide the search property of a custom widget
		 */
		_getSearchableFieldValue: function(value) {
			return value.title;
		}
	});

	return WidgetListView;
});
